<template>
  <div>
    <i-drawer
      v-model="_drawer"
      placement="right"
      title="詳細検索"
      :closable="false"
      @on-visible-change="onVisibleChange"
      width="650"
      class="drawer-search-detail"
    >
      <div class="drawer">
        <i-row class="drawer__row">
          <i-col>
            <i-button type="primary" size="small" icon="ios-search" @click="onSearch()">検索</i-button>
          </i-col>
        </i-row>
        <i-row class="drawer__row">
          <i-col span="6" class="drawer__col">
            <i-input
              v-model="search.control_no"
              size="small"
              placeholder="物件管理番号"
              @on-enter="onSearch()"
            ></i-input>
          </i-col>
          <i-col span="6" class="drawer__col">
            <i-input v-model="search.matter_no" size="small" placeholder="案件No"></i-input>
          </i-col>
          <i-col span="8" class="drawer__col">
            <i-input
              size="small"
              v-model="search.property_name"
              placeholder="物件名もしくはカナ"
              @on-enter="onSearch()"
            ></i-input>
          </i-col>
          <i-col span="4">
            <i-input size="small" v-model="search.room_no" placeholder="部屋番号"></i-input>
          </i-col>
        </i-row>
        <i-row class="drawer__row">
          <i-col span="9" class="drawer__col">
            <i-input
              size="small"
              v-model="search.address_str"
              placeholder="住所(スペース区切りでor検索)"
              @on-enter="onSearch()"
            ></i-input>
          </i-col>
          <i-col span="5" class="drawer__col">
            <i-input
              v-model="search.address_else1"
              size="small"
              placeholder="住居表示"
              @on-enter="onSearch()"
            ></i-input>
          </i-col>
          <i-col span="10">
            <i-input
              v-model="search.station_name"
              size="small"
              placeholder="駅名(スペース区切りでor検索)"
              @on-enter="onSearch()"
            ></i-input>
          </i-col>
        </i-row>
        <i-row class="drawer__row">
          <i-col span="24">
            <i-tabs value="name1">
              <i-tab-pane label="詳細" name="name1">
                <SearchDetails :type="type" />
              </i-tab-pane>

              <i-tab-pane :label="labelLand" name="name2">
                <SearchLands />
              </i-tab-pane>

              <i-tab-pane :label="labelBuilding" name="name3">
                <SearchBuildings />
              </i-tab-pane>
              <i-tab-pane :label="labelRoom" name="name4">
                <SearchRooms />
              </i-tab-pane>
            </i-tabs>
          </i-col>
        </i-row>
      </div>
    </i-drawer>
  </div>
</template>

<script>
import { Drawer, Button, Row, Col, Tabs, TabPane, Input } from 'view-design'
import SearchDetails from './SearchDrawerDetails'
import SearchLands from './SearchDrawerLands'
import SearchBuildings from './SearchDrawerBuildings'
import SearchRooms from './SearchDrawerRooms'
import BuildingEquipments from '@/constants/building_equipments'
import RoomEquipments from '@/constants/room_equipments'
export default {
  components: {
    'i-drawer': Drawer,
    'i-button': Button,
    'i-row': Row,
    'i-col': Col,
    'i-tabs': Tabs,
    'i-tab-pane': TabPane,
    'i-input': Input,
    SearchDetails,
    SearchLands,
    SearchBuildings,
    SearchRooms,
  },
  props: {
    drawer: {
      type: Boolean,
      default: false,
      requied: true,
    },
    type: {
      type: String,
      default: '',
      required: true,
      validator: function(value) {
        return ['investment', 'residence'].indexOf(value) !== -1
      },
    },
  },
  data() {
    return {
      buildingEquipments: BuildingEquipments,
      roomEquipments: RoomEquipments,
      labelLand: h => {
        return h('div', { class: 'badge-wrap' }, [
          h('span', '土地情報'),
          h('span', { class: 'badge' }, this.searchLandNum),
        ])
      },
      labelBuilding: h => {
        return h('div', { class: 'badge-wrap' }, [
          h('span', '建物情報'),
          h('span', { class: 'badge' }, this.searchBuildingNum),
        ])
      },
      labelRoom: h => {
        return h('div', { class: 'badge-wrap' }, [
          h('span', '部屋情報'),
          h('span', { class: 'badge' }, this.searchRoomNum),
        ])
      },
    }
  },
  computed: {
    _drawer: {
      get() {
        return this.drawer
      },
      set(val) {
        this.$emit('update:drawer', val)
      },
    },
    search: {
      get() {
        return this.$store.getters['SearchProperty/getSearch']
      },
      set(val) {
        this.$store.commit('SearchProperty/setSearch', val)
      },
    },
    searchLandNum() {
      let count = 0
      if (this.search.right_of_site) count++
      if (this.search.land_area) count++
      if (this.search.land_coverage_ratio) count++
      if (this.search.land_capacity_ratio) count++
      return count
    },
    searchBuildingNum() {
      let count = 0
      if (this.search.floor) count++
      if (this.search.floor_area) count++
      if (
        this.search.build_y_from ||
        this.search.build_m_from ||
        this.search.build_y_to ||
        this.search.build_m_to ||
        this.search.f_new_building
      )
        count++
      if (this.search.land_capacity_ratio) count++
      const self = this
      _.forEach(this.buildingEquipments, function(item) {
        _.forEach(item.checkbox, function(checkbox) {
          if (self.search[`${checkbox.value}`]) count++
        })
      })
      return count
    },
    searchRoomNum() {
      let count = 0
      if (this.search.floor_no) count++
      if (this.search.balcony_area) count++
      if (
        this.search.number_of_rooms_from ||
        this.search.number_of_rooms_to ||
        (this.search.mi_floor_plan_cd && this.search.mi_floor_plan_cd.length > 0)
      )
        count++
      if (this.search.exclusive_area) count++
      if (this.search.room_size) count++
      if (
        (this.search.parking_exist && this.search.parking_exist.length > 0) ||
        this.search.parking_fee_from ||
        this.search.parking_fee_to
      )
        count++
      const self = this
      _.forEach(this.roomEquipments, function(item) {
        _.forEach(item.checkbox, function(checkbox) {
          if (self.search[`${checkbox.value}`]) count++
        })
      })
      return count
    },
  },
  methods: {
    // ドロワー 表示/非表示 切り替え時の処理
    onVisibleChange(isOpen) {
      if (isOpen) {
        // 表示時処理
      } else {
        // 非表示時処理
      }
    },
    // 検索ボタン クリック処理
    onSearch() {
      this.$emit('search')
      this._drawer = false
    },
  },
}
</script>

<style lang="scss" scoped>
.drawer-search-detail {
  .drawer {
    &__row {
      margin-bottom: 8px;
    }
    &__col {
      padding-right: 4px;
    }
  }
  .ivu-form-item {
    margin-bottom: 8px;
  }
  .ivu-form .ivu-form-item-label {
    font-weight: bold;
  }
}
</style>
<style lang="scss">
.drawer-search-detail {
  .badge-wrap {
    position: relative;
  }
  .badge {
    position: absolute;
    top: -8px;
    right: -24px;
    background-color: #f00;
    color: #fff;
    border-radius: 99px;
    padding: 2px 8px;
    font-size: 12px;
  }

  .ivu-form .ivu-form-item-label {
    font-weight: bold;
  }

  .label {
    display: inline-block;
    width: 60px;
    font-weight: bold;
  }
}
</style>
